export const styles = {
  root: {
    display: "flex",
    borderBottom: "1px solid",
    borderColor: "divider",
    bgcolor: "background.paper",
    overflowX: "auto",
    flexShrink: 0,
    "&::-webkit-scrollbar": { height: 4 },
    "&::-webkit-scrollbar-thumb": { bgcolor: "divider", borderRadius: 2 }
  },
  tab: (active: boolean) => ({
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    px: 1.5,
    py: 0.75,
    cursor: "pointer",
    borderBottom: "2px solid",
    borderColor: active ? "primary.main" : "transparent",
    color: active ? "primary.main" : "text.secondary",
    maxWidth: 200,
    minWidth: 80,
    flexShrink: 0,
    userSelect: "none",
    "&:hover": { bgcolor: "action.hover" }
  }),
  label: {
    flex: 1,
    fontSize: "0.8125rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  closeButton: {
    p: 0.25,
    flexShrink: 0,
    "& svg": { fontSize: "0.875rem" }
  },
  alert: {
    width: "100%"
  }
} as const;
